import { render, staticRenderFns } from "./NumberThreeSVG.vue?vue&type=template&id=381fba1c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fba1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381fba1c')) {
      api.createRecord('381fba1c', component.options)
    } else {
      api.reload('381fba1c', component.options)
    }
    module.hot.accept("./NumberThreeSVG.vue?vue&type=template&id=381fba1c&scoped=true&", function () {
      api.rerender('381fba1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberThreeSVG.vue"
export default component.exports